import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="work-types--table"
export default class extends Controller {
  static targets = ["table"];
  
  edit(event) {
    const row = event.currentTarget;
    const url = row.dataset.editUrl;
    Turbo.visit(url, { frame: 'work-type-form' });
    this.resetSelectedEntry();
    row.classList.add('selected');
  }

  resetSelectedEntry() {
    this.tableTarget
        .querySelectorAll('tr')
        .forEach(tr => tr.classList.remove('selected'));
  }
}
